export function normalizePaginate(payload) {
  if (!payload) return { items: [], meta: {} };

  // Many services use { data: { items: [...] } } or { data: [...] }
  if (Array.isArray(payload)) return { items: payload, meta: {} };

  const items =
    payload.items ||
    payload.data ||
    payload.results ||
    payload.rows ||
    [];

  const meta = {
    page:
      payload.page ||
      payload.current_page ||
      payload.meta?.page ||
      payload.meta?.current_page,
    total:
      payload.total ||
      payload.total_items ||
      payload.objects?.total ||
      payload.meta?.total,
    items_per_page:
      payload.items_per_page ||
      payload.per_page ||
      payload.meta?.items_per_page ||
      payload.meta?.per_page
  };

  return { items: Array.isArray(items) ? items : [], meta };
}

